// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
  }
  
  /* Add semi-transparent background using ::before */
  body::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('https://res.cloudinary.com/daf2hsxuj/image/upload/v1742467211/ezfyte7v3uiilhimdiol.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    opacity: 0.5;
    z-index: -1;
  }
  

/* Container */
.signin-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  
  /* Wrapper */
  .signin-wrapper {
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: row;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;
    background-color: white;
  }
  
  /* Left Side: Welcome Section */
  .left-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgb(0, 0, 0);
    padding: 40px;
    background-image: url('https://res.cloudinary.com/daf2hsxuj/image/upload/v1742467210/xnfvytfd3wxcaujqzhzq.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
  }
  
  /* Right Side: Login Form */
  .right-section {
    flex: 1 1;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }
  
  /* Form Inputs */
  .input-field {
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  
  /* Submit Button */
  .submit-button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  /* Text Center */
  .text-center {
    text-align: center;
    margin-top: 10px;
  }
  
  /* 📱 HIDE LEFT SECTION ON MOBILE & TABLET */
  @media (max-width: 1024px) {
    .left-section {
      display: none; 
    }
  
    .signin-wrapper {
      flex-direction: column;
    }
  
    .right-section {
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Signin/SignIn.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;EACZ;;EAEA,mDAAmD;EACnD;IACE,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+GAA+G;IAC/G,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,YAAY;IACZ,WAAW;EACb;;;AAGF,cAAc;AACd;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA,YAAY;EACZ;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,+BAA+B;EAC/B;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,+GAA+G;IAC/G,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA,2BAA2B;EAC3B;IACE,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA,gBAAgB;EAChB;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,4CAA4C;EAC5C;IACE;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;IACb;EACF","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n  }\n  \n  /* Add semi-transparent background using ::before */\n  body::before {\n    content: \"\";\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url('https://res.cloudinary.com/daf2hsxuj/image/upload/v1742467211/ezfyte7v3uiilhimdiol.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    opacity: 0.5;\n    z-index: -1;\n  }\n  \n\n/* Container */\n.signin-container {\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n  }\n  \n  /* Wrapper */\n  .signin-wrapper {\n    width: 100%;\n    max-width: 900px;\n    display: flex;\n    flex-direction: row;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    overflow: hidden;\n    background-color: white;\n  }\n  \n  /* Left Side: Welcome Section */\n  .left-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: rgb(0, 0, 0);\n    padding: 40px;\n    background-image: url('https://res.cloudinary.com/daf2hsxuj/image/upload/v1742467210/xnfvytfd3wxcaujqzhzq.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    text-align: center;\n  }\n  \n  /* Right Side: Login Form */\n  .right-section {\n    flex: 1;\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  /* Form Inputs */\n  .input-field {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 15px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n  }\n  \n  /* Submit Button */\n  .submit-button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  /* Text Center */\n  .text-center {\n    text-align: center;\n    margin-top: 10px;\n  }\n  \n  /* 📱 HIDE LEFT SECTION ON MOBILE & TABLET */\n  @media (max-width: 1024px) {\n    .left-section {\n      display: none; \n    }\n  \n    .signin-wrapper {\n      flex-direction: column;\n    }\n  \n    .right-section {\n      width: 100%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
